import { v4 as uuid } from 'uuid';
import { store } from '../stores/store';

export interface EmailNew {
  id: string;
  email: string;
  email_copy: string;
  subject: string;
  body: string;
  filename: string;
  model: string;
  status: boolean;
  dateTime: any;
  read?: boolean;
}

function sendRespectiveEmail(
  type: string,
  name: string,
  subject: string,
  value: string,
  msg?: string,
  email?: string,
  mailBody?: string,
  noToast?:boolean
) {
 
  function getEmailCopy() {
    if (store.commonStore.hfcCustomerChanges) {
      return store.userStore?.user?.email ===
        'Alexandra.carabello@hfcmediaservices.com'
        ? ''
        : 'Alexandra.carabello@hfcmediaservices.com';
    } else {
      return 'prasaddevnew@gmail.com';
    }
  }
  if (
    store.userStore.user?.customerName !== 'Restoration' &&
    store.userStore.user?.customerName !== 'NFAI' &&
    window.location.hostname !== 'localhost'
  ) {
    const typeData =
      type === 'created' || type === 'create'
        ? store.userStore.emailDetails.created
        : type === 'cloned'
          ? store.userStore.emailDetails.cloned
          : type === 'Notification'
            ? store.userStore.emailDetails.Notification
            : type === 'deleted'
              ? store.userStore.emailDetails.deleted
              : type === 'edited'
                ? store.userStore.emailDetails.edited
                : store.userStore.emailDetails.modified;
    const emailData = {
      ...store.userStore.email,
      id: uuid(),
      email: `${email || store.userStore?.user?.email}`,
      email_copy: `${getEmailCopy()}`,
      subject: `${subject}`,
      // body: `Dear Name<br/> This is asdsdsdsd reminder for returning the Asset as the due date. Due Date has passed.<br/><br/>Thanks<br/>Admin Name`,
      body: mailBody
        ? mailBody
        : `Dear ${store.userStore?.user?.displayName},<br/>\u00A0 ${
            typeData || ''
          } ${name || ''} ${msg || ''} ${
            store.userStore.emailDetails.Date
          }. <br/> <br/> Regards, <br/> info@honeycombmanager.com
    `,
      filename: '',
      dateTime: new Date().toISOString(),

      /* eslint-disable */
      model: `{ \"name\":\"${store.userStore?.user?.displayName}\", \"company\":\"${store.userStore?.user?.displayName}\" }`,
    };
    store.activityStore.sendEmail(emailData, value,noToast || false);
  }
}

export default sendRespectiveEmail;
